<script lang="ts">
	import Logo from '$lib/components/logo.svelte';
	import * as Sidebar from '$lib/components/ui/sidebar';

	import { semanticVersion } from '$lib/constants';
	import * as m from '$lib/paraglide/messages';
</script>

<Sidebar.Menu>
	<Sidebar.MenuItem>
		<Sidebar.MenuButton size="lg">
			{#snippet child({ props })}
				<a href="/" {...props}>
					<div
						class="bg-sidebar-primary flex aspect-square size-8 items-center justify-center rounded-lg"
					>
						<Logo class="fill-sidebar-primary-foreground" />
					</div>

					<div class="flex items-center justify-between w-full">
						<span class="font-semibold text-lg">
							{m.productName()}
						</span>

						<span class="text-muted-foreground text-xs" aria-label="App version">
							v{semanticVersion}
						</span>
					</div>
				</a>
			{/snippet}
		</Sidebar.MenuButton>
	</Sidebar.MenuItem>
</Sidebar.Menu>
